import { Dialog } from '@material-ui/core';
import { Button, Stack, Text } from '@solvhealth/jigsaw-v1';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import history from '~/core/history';
import useToggleRuntimeModal from '~/hooks/runtime/useToggleRuntimeModal';
import Layout from '~/routes/book/components/Layout';
import {
  MEMBER_TELEMED_VISIT_COST_CENTS,
  MEMBERSHIP_NAME,
  PREMIUM_TELEMED_SLA_MINUTES,
} from '../constants';
import { centsToCurrencyStr } from '~/core/util/currency';

export const MEMBERSHIP_SUCCESS_DIALOG = 'membership-success';

type Props = {
  forceOpen?: boolean;
};

const HeroImage = styled.img.withConfig({ componentId: 'sc-fgsqe3-0' })`
  width: 169px;
  height: 151px;
  object-fit: cover;
`;

const BorderBoxReset = styled.div.withConfig({ componentId: 'sc-fgsqe3-1' })`
  & {
    *,
    *::before,
    *::after {
      box-sizing: border-box;
    }
  }
`;

const SuccessDialog = ({ forceOpen }: Props) => {
  const [open, toggle] = useToggleRuntimeModal(MEMBERSHIP_SUCCESS_DIALOG);

  const { t } = useTranslation(['common', 'membership']);

  const goToBook = () => {
    toggle();
    history.push('/book');
  };

  return (
    <Dialog fullScreen fullWidth maxWidth="xs" onClose={toggle} open={forceOpen || open}>
      <BorderBoxReset>
        <Layout hideBackButton>
          <Stack
            alignItems="center"
            justifyContent="center"
            justifySelf="stretch"
            pb={2}
            pt={6}
            px={2}
            space={3}
            textAlign="center"
          >
            <HeroImage alt="hero image" src="/images/membership/success.svg" />

            <Stack space={1}>
              <Text variant="h2">{t('membership:successDialog.title', { MEMBERSHIP_NAME })}</Text>
              <Text muted>
                {t('membership:successDialog.subtitle', {
                  TELEMED_VISIT_COST_STRING: centsToCurrencyStr(MEMBER_TELEMED_VISIT_COST_CENTS),
                  PREMIUM_TELEMED_SLA_MINUTES,
                })}
              </Text>
            </Stack>

            <Stack space={1} width="100%">
              <Button fullWidth onClick={toggle}>
                {t('membership:successDialog.cta')}
              </Button>
            </Stack>
          </Stack>
        </Layout>
      </BorderBoxReset>
    </Dialog>
  );
};

export default SuccessDialog;
